<template>

  <div class="reservation">

    <div class="block-group">
      <div class="block">
        <div class="block-head">
          {{$t('Information')}}
        </div>
        <div class="block-content">
          <el-form :model="information" :rules="rules" ref="informationForm">
            <div class="form-row">
              <el-form-item prop="Arrival" :label="$t('Arrival Date')">
                <el-date-picker
                  :placeholder="$t('Arrival Date')"
                  v-model="information.Arrival"
                  value-format="yyyy-MM-dd"
                  format="MM/dd/yyyy"
                  :picker-options="startTimeOptions"
                  style="width: 100%;"
                />
                <span class="format">{{ information.Arrival | dateFormat(that)}}</span>
              </el-form-item>
              <div class="line"></div>
              <el-form-item prop="Departure" :label="$t('Departure Date')">
                <el-date-picker
                  :placeholder="$t('Departure Date')"
                  v-model="information.Departure"
                  format="MM/dd/yyyy"
                  value-format="yyyy-MM-dd"
                  :picker-options="endTimeOptions"
                  :default-value="defaultEndDay"
                  style="width: 100%;"/>
                <span class="format">{{ information.Departure | dateFormat(that)}}</span>
              </el-form-item>
            </div>
            <div class="form-row">
              <el-form-item :label="$t('Adults Per Room')">
                <el-select v-model="information.Adults" :placeholder="$t('Choosing')">
                  <el-option value="1"/>
                  <el-option value="2"/>
                  <el-option value="3"/>
                </el-select>
              </el-form-item>
              <el-form-item :label="$t('Child Per Room')" class="child-form">
                <el-select v-model="information.Children" :placeholder="$t('Choosing')">
                  <el-option :value="val-1" v-for="val of 4" :key="val"/>
                </el-select>
              </el-form-item>
              <el-form-item :label="$t('Hotel')" class="hotel-form">
                <el-select v-model="information.hotel">
                  <el-option value="all" :label="$t('All Hotels')"/>
                  <el-option v-for="(hotel,index) of hotels" :label="hotel.name" :value="hotel.code" :key="index"/>
                </el-select>
              </el-form-item>
              <div class="el-form-item">
                <button class="actions-search primary" @click.prevent="search(false)">{{$t('Search')}}</button>
              </div>
            </div>
          </el-form>
        </div>
      </div>
      <div class="block" v-if="userInfo">
        <div class="block-head">
          {{$t('Account Profile')}}
        </div>
        <div class="block-content">

          <table>
            <tr>
              <th>{{$t('Name')}}：</th>
              <td>{{userInfo.name}}</td>
            </tr>
            <tr>
              <th>{{$t('Profile Name')}}:</th>
              <td>{{userInfo.travel_agent_name}}</td>
            </tr>
            <tr>
              <th>{{$t('Last Login')}}:</th>
              <td>{{userInfo['last_login_'+currentLang]}}</td>
            </tr>
          </table>

        </div>
      </div>
    </div>
    <div class="block select-room" v-if="hotelTables.length">
      <div class="block-head">
        {{$t('Select Room(s)')}}
        <div class="actions-toolbar">
          <button
            v-if="showPrevious"
            class="primary"
            @click.prevent="changeDay(-1)"
          >
            &lt;&lt; {{$t('Previous 7 days')}}
          </button>
          <button
            class="primary"
            @click.prevent="changeDay(1)"
          >
            {{$t('Next 7 days')}} >>
          </button>
        </div>
      </div>
      <div class="block-content">
        <el-form :model="information" :rules="rules" ref="hotelTable">
          <div class="hotel-table" v-for="(hotel,hotel_index) of hotelTables" :key="hotel_index">
            <div class="hotel-label">
              <span>{{hotel.hotel_name}}</span>
              <p v-if="hotel_index===0">
                {{$t("When it is less than %{s} rooms, the rate is displayed in red color.",
                {s:minimum_inventory_reminder})}}</p>
            </div>
            <div class="hotel-table-box">
              <table>
                <tr>
                  <th>{{$t('Numbers of Rooms')}}</th>
                  <th>{{$t('Rate Name')}}</th>
                  <th>{{$t('Room Name')}}</th>
                  <th
                    :class="{active:endTime > day && startTime <= day}"
                    v-for="(day,index) of week"
                    :key="index">
                    {{whatDay(day)}} ({{day | timeToDay}})
                  </th>
                </tr>
                <tr v-for="(room,room_index) of hotel.roomType" :key="room_index">
                  <td>
                    <el-form-item>
                      <el-select class="qty-select" v-model="hotelTables[hotel_index].roomType[room_index].num_room">
                        <el-option :label="0" :value="0"/>
                        <el-option v-for="n of room.min" :label="n" :value="n" :key="n"/>
                      </el-select>
                    </el-form-item>
                  </td>
                  <td>
                    <el-form-item>
                      <el-select v-model="hotelTables[hotel_index].roomType[room_index].rate_code"
                                 :placeholder="$t('Choosing')">
                        <el-option v-for="(rate,rate_index) of room.rate" :label="rate.RateName"
                                   :value="rate.RateCode" :key="rate_index"/>
                      </el-select>
                    </el-form-item>
                  </td>
                  <td>
                    {{room.type_name}}
                  </td>
                  <td
                    :class="{active:endTime > day && startTime <= day,
                    empty:day<new Date()-86400000,
                    red:room.detail[index].room<minimum_inventory_reminder,
                    gray:!room.detail[index].room
                  }"
                    v-for="(day,index) of week"
                    :key="index">
                    {{room.detail[index].room?$t('Available'):$t('Closed')}}
                    <span class="room-qty">({{room.detail[index].room}})</span>
                  </td>
                </tr>
              </table>
            </div>

          </div>
        </el-form>
      </div>
    </div>

    <button class="primary action-submit" @click="submit" v-if="hotelTables.length">{{$t('Submit')}}</button>

  </div>

</template>

<script>
  import util from '@/util';

  export default {
    props: [],
    data: function () {
      const checkDay = (rule, value, callback) => {
        if (new Date(value) <= new Date(this.information.Arrival)) {
          return callback(new Error(this.$t('The departure date must be later than the arrival date')));
        } else {
          callback()
        }
      };
      return {
        information: {
          Arrival: '',
          Departure: '',
          Adults: '1',
          Children: '0',
          hotel: 'all'
        },
        rules: {
          Arrival: [
            {required: true, message: this.$t('Arrival is require'), trigger: 'change'},
          ],
          Departure: [
            {required: true, message: this.$t('Departure is require'), trigger: 'change'},
            {validator: checkDay, trigger: 'change'}
          ]
        },
        hotels: [],
        minimum_inventory_reminder: '',
        maximum_reservation: '',
        currentPage: 1,
        //模拟数据
        hotelTables: [],
        that: this
      }
    },
    methods: {
      roomTotal() {
        this.axios.get('/api/junket/info/configs', {}).then((res) => {
          if (res.code === 200) {
            this.minimum_inventory_reminder = res.data.minimum_inventory_reminder
            this.maximum_reservation = res.data.maximum_reservation
          }
        })
      },
      search(isPage) {
        if (!isPage) {
          this.currentPage = 1
        }
        this.$refs.informationForm.validate((valid) => {
            if (valid) {
              if (!isPage) {
                this.$store.commit('stateChange', {k: 'roomSearch', v: this.pubInfo})
              }
              const d = this.information;
              const start_date = util.dateStr(new Date(this.week[0]))
              const loading = this.$loading({
                lock: true,
                text: 'Loading',
                spinner: 'el-icon-loading',
                background: 'rgba(0, 0, 0, 0.7)'
              });
              this.axios.get('/api/junket/info/inventory', {
                params: {
                  arrival: d.Arrival,
                  departure: d.Departure,
                  adults: d.Adults,
                  child: d.Children,
                  hotel_code: d.hotel,
                  start_date
                }
              }).then((res) => {
                if (res.code === 200) {
                  this.hotelTables = res.data;
                  if (!this.hotelTables.length) {
                    this.$message.warning(this.$t('There is no suitable room !'));
                  } else {
                    if (this.hotelTables.every((hotel) => hotel.is_across) && !isPage) {
                      this.$message.warning(this.$t('block across !'));
                    }
                  }
                }
              }).finally(() => {
                loading.close();
              })
            }
          }
        );
      },
      getHotels() {
        this.axios.get('api/junket/info/hotels')
          .then((res) => {
              if (res.code === 200) {
                this.hotels = res.data.hotels
              }
            }
          )
      }
      ,
      submit() {

        if (!this.rooms.length) {
          this.$message.error(this.$t("You haven't chosen room yet !"));
        } else if (this.dayLong > this.maximum_reservation) {
          this.$message.error(this.$t('The maximum reservation days cannot exceed {s} !', {s: this.maximum_reservation}));
        } else {
          let obj = {}
          this.rooms.forEach((room, index) => {
            obj['room_' + (index + 1)] = room
          })
          this.$store.commit('stateChange', {k: 'roomOrigin', v: obj})
          this.$router.push({path: '/booking'})
        }
      }
      ,
      changeDay(page) {
        this.currentPage += page
        this.search(true)
      }
      ,
      whatDay(time) {
        let week = [this.$t('SUN'), this.$t('MON'), this.$t('TUE'), this.$t('WED'), this.$t('THUR'), this.$t('FRI'), this.$t('SAT')]
        let day = new Date(time).getDay()
        return week[day]
      }
    },
    computed: {
      currentLang() {
        return this.$i18n.locale
      },
      startTimeOptions() {
        return {
          disabledDate: (time) => {
            //今天之前的时间不能作为起始时间
            let yesterday = new Date();
            yesterday.setDate(yesterday.getDate() - 1);
            return time.getTime() < yesterday.getTime() || this.information.Departure && new Date(time) > new Date(this.information.Departure);
          }
        }
      }
      ,
      endTimeOptions() {
        return {
          disabledDate: (time) => {
            //今天之前的时间不能作为起始时间
            let yesterday = new Date();
            yesterday.setDate(yesterday.getDate() - 1);
            return time.getTime() < yesterday.getTime() || new Date(time) <= new Date(this.information.Arrival);
          }
        }
      }
      ,
      userInfo() {
        return this.$store.state.userInfo
      }
      ,
      pubInfo() {
        return {
          Arrival_Date: this.information.Arrival,
          Departure_date: this.information.Departure,
          Adults_per: this.information.Adults,
          Child_per: this.information.Children
        }
      }
      ,
      rooms() {
        let arr = []
        this.hotelTables.forEach(function (hotel) {
          hotel.roomType.forEach(function (room) {
            if (room.num_room) {
              for (let n = 0; n < room.num_room; n++) {
                let obj = {
                  Hotel_code: {
                    code: hotel.hotel_code,
                    name: hotel.hotel_name
                  },
                  Roomtype_code: {
                    code: room.type_code,
                    name: room.type_name
                  },
                  Rate_code: {
                    code: room.rate_code,
                    name: room.rate.find((x) =>
                      x.RateCode === room.rate_code
                    ).RateName
                  },
                }
                arr.push(obj)
              }
            }
          })
        })
        return arr
      }
      ,
      //开始日期所在的周的周日
      sunday() {
        let startDay = this.$store.state.roomSearch?.Arrival_Date
        let da = new Date(util.dateArr(startDay));
        let weekday = da.getDay();
        da.setDate(da.getDate() - weekday);
        return new Date(da)
      }
      ,
      //以星期天开始的一周
      week0() {
        let arr = [this.sunday]
        for (let day = 1; day < 7; day++) {
          arr.push(new Date(this.sunday).setDate(new Date(this.sunday).getDate() + day))
        }
        return arr
      }
      ,
      week() {
        let start = new Date(this.startTime).setDate(new Date(this.startTime).getDate() + (this.currentPage - 1) * 7)
        let arr = [start]
        for (let day = 1; day < 7; day++) {
          arr.push(new Date(start).setDate(new Date(start).getDate() + day))
        }
        return arr
      }
      ,
      startTime() {
        return new Date(this.$store.state.roomSearch.Arrival_Date)
      }
      ,
      endTime() {
        return new Date(this.$store.state.roomSearch.Departure_date)
      }
      ,
      //定几天房
      dayLong() {
        return (this.endTime - this.startTime) / 1000 / 60 / 60 / 24
      }
      ,
      //已选间晚数
      numNight() {
        let num = 0
        this.hotelTables.forEach((hotel) => {
          hotel.roomType.forEach((room) => {
            if (room.num_room) {
              num += room.num_room * this.dayLong
            }
          })
        })
        return num
      }
      ,
      //总页数
      pages() {
        return Math.ceil(this.dayLong / 7)
      },
      //是否显示上一页
      showPrevious() {
        let today = new Date();
        return today < this.week[0]
      },
      defaultEndDay() {
        let day = ''
        if (this.information.Arrival) {
          day = this.information.Arrival
        }
        return day
      }
    }
    ,
    created() {
      this.getHotels();
      this.roomTotal();
    }
    ,
    filters: {
      timeToDay(time) {
        let _time = new Date(time)
        let month = _time.getMonth() + 1;
        let day = _time.getDate();
        if (month < 10) {
          month = '0' + month
        }
        if (day < 10) {
          day = '0' + day
        }
        return month + "/" + day
      },
    }
  }

</script>

